import AvatarManager from './AvatarManager';

export default AvatarManager;
export { AvatarManager };
